import { render, staticRenderFns } from "./LuBillableCategory.vue?vue&type=template&id=47201166&"
import script from "./LuBillableCategory.vue?vue&type=script&lang=js&"
export * from "./LuBillableCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports